import type { IconDef } from '../types';

export const close: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M13.4125 12.0025L22.7125 2.7125C23.1025 2.3225 23.1025 1.6925 22.7125 1.3025C22.3225 0.9125 21.6925 0.9125 21.3025 1.3025L12.0025 10.5925L2.7125 1.2925C2.3225 0.9025 1.6825 0.9025 1.2925 1.2925C0.9025 1.6825 0.9025 2.3225 1.2925 2.7125L10.5925 12.0025L1.2925 21.2925C0.9025 21.6825 0.9025 22.3125 1.2925 22.7025C1.4925 22.9025 1.7425 22.9925 2.0025 22.9925C2.2625 22.9925 2.5125 22.8925 2.7125 22.7025L12.0025 13.4125L21.2925 22.7025C21.4925 22.9025 21.7425 22.9925 22.0025 22.9925C22.2625 22.9925 22.5125 22.8925 22.7125 22.7025C23.1025 22.3125 23.1025 21.6825 22.7125 21.2925L13.4125 12.0025Z',
    },
  ],
};
